import { render, staticRenderFns } from "./indexSecurity.vue?vue&type=template&id=2c70ad9c&scoped=true&"
import script from "./indexSecurity.vue?vue&type=script&lang=js&"
export * from "./indexSecurity.vue?vue&type=script&lang=js&"
import style0 from "./indexSecurity.vue?vue&type=style&index=0&id=2c70ad9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70ad9c",
  null
  
)

export default component.exports